import { Fragment } from "preact";
import Center from "../../../../components/center";
import Editorial from "../../../../components/editorial";
import Head from "../../../../components/head";
import Hero from "../../../../components/hero";
import Ligature from "../../../../components/ligature";
import CandidateBio from "../../../../components/candidate-bio";
import { Link } from "preact-router";

const candidate = {
  name: "Erica Floden",
  since: 2008,
  email: "efloden@hotmail.com",
  photo: "/images/candidates/erica-floden.jpg",
};

const pageTitle = `2025 - ${candidate.name} - Klahanie.info`;

const questions = [
  {
    question: "Why you are interested in joining the Board of Directors?",
    answer: (
      <p>
        Being a proud resident for 16 years, I am committed to ensuring that the
        Klahanie community thrives as a place where homeowners feel confident
        about their largest investment—their homes. My goal is to promote
        transparency and ensure responsible use of HOA fees. As a board member,
        I will anchor board decisions in homeowner interests and feedback and
        uphold all stipulated rules.
      </p>
    ),
  },
  {
    question: "What do you see as the Klahanie Board’s top priority?",
    answer: (
      <p>
        Since home ownership is the largest investment for many Klahanie
        residents, including my own family, I believe that the Klahanie Board’s
        top priority is to safeguard that investment and to use responsible
        stewardship to invest in the community with the intent of maintaining
        and investing in neighborhood amenities which increase home values.
        Within the scope of this responsibility, the board is beholden to the
        homeowners who should benefit from transparency around investments and
        decision making.
      </p>
    ),
  },
  {
    question:
      "What areas of focus would you like to see the Klahanie Board address during your term?",
    answer: (
      <Fragment>
        <p>
          The number one area of focus is the decision making and the process
          around the investments in pool and building upgrades. This is a
          significant investment and needs to follow HOA published rules
          including transparency and engagement of homeowners, as there is a
          significant financial impact to the community.
        </p>
        <p>
          With my background in contract management, I would like to see a
          comprehensive audit of all current contractors, to ensure that the
          Klahanie community is benefiting from the best values on the market.
        </p>
        <p>
          Identify, review and implement natural disaster plans to account for
          future bomb cyclones, earthquakes and other potential natural events
          which have a negative impact on the community.
        </p>
        <p>
          Klahanie is a diverse community in terms of culture, age, income and
          lifestyles. Within this framework, it is imperative that proactive
          communication and engagement be a core foundation of the board
          regarding investments and special assessments.
        </p>
      </Fragment>
    ),
  },
  {
    question:
      "What knowledge and experience will you bring to the Klahanie Board?",
    answer: (
      <Fragment>
        <p>
          I bring extensive experience across various industries, including
          construction management, community transportation, energy and
          aviation. My professional background in business operations, project
          management, contract negotiation, and financial control positions me
          to contribute effectively to the board. I prioritize teamwork, respect
          for diverse opinions, and building consensus to achieve long-term
          financial stability and community growth.
        </p>
        <p>
          Having lived in four countries and being fluent in multiple languages,
          I deeply value diversity and inclusion. I understand the importance of
          assembling balanced teams with complementary skills and perspectives
          to create a thriving community. My experience includes volunteer work
          with organizations such as the Issaquah Chamber of Commerce, the
          Issaquah School District and Amnesty International, which has further
          strengthened my commitment to community service.
        </p>
      </Fragment>
    ),
  },
  {
    question: "Please share your background, work history, and skill set.",
    answer: (
      <Fragment>
        <p>
          I hold an MBA in Finance and am known for my ability to build
          collaborative teams, encourage innovation, and drive results. For more
          details about my professional background, please visit my{" "}
          <Link
            target="_blank"
            rel="noreferrer"
            href="https://www.linkedin.com/in/erica-flod%C3%A9n-937724a/"
          >
            LinkedIn profile
          </Link>
          .
        </p>
        <p>
          My family and I have been proud residents of Klahanie since 2008 and
          homeowners since 2010. We cherish the community’s opportunities for
          sports, recreation and nature, and I am dedicated to fostering its
          continued growth. My husband and I, along with our three children
          enjoy hiking, skiing and traveling. We are also heavily involved in
          supporting our children’s pursuits in sports, music, arts and
          academics.
        </p>
      </Fragment>
    ),
  },
];

const EricaFloden = () => (
  <Editorial>
    <Head title={pageTitle} />
    <Hero background="/images/backgrounds/forest-path.jpg">
      <h1>
        <span style="font-size: 0.5em; font-weight: 400; display: block; margin-bottom: 0.25em; text-transform: none;">
          Vote for{" "}
        </span>
        <Ligature>{candidate.name}</Ligature>
      </h1>
      <h2 style="font-size: 1.1em; font-weight: 400;">
        <span>Klahanie resident since {candidate.since}</span>
      </h2>
    </Hero>
    <div>
      <Center>
        <CandidateBio
          img={candidate.photo}
          name={candidate.name}
          since={candidate.since}
          email={candidate.email}
          questions={questions}
        >
          <p>
            My family and I have been proud homeowners since 2010. We cherish
            this diverse community and its opportunities for sports, recreation
            and nature, and I am dedicated to fostering its continued growth.
          </p>
          <p>
            As a board member I would be committed to ensuring that the Klahanie
            community thrives as a place where homeowners feel confident about{" "}
            <strong>their largest investment—their homes</strong>.
          </p>
          <p>
            I believe that the Klahanie Board’s top priority is{" "}
            <strong>to through democratic and transparent processes</strong>{" "}
            safeguard that investment to achieve long-term financial stability
            and community growth.{" "}
            <strong>
              My number one area of focus is the decision making and the process
              around the investments in pool and building upgrades.
            </strong>{" "}
            This is a significant investment with large financial impact and
            needs to follow HOA published rules including transparency and
            engagement of homeowners.
          </p>
          <p>
            I’d also like to see a comprehensive audit of all{" "}
            <strong>current contractors</strong>, to ensure that the Klahanie
            community is benefiting from the best values on the market, and{" "}
            <strong>
              identify, review and implement natural disaster plans
            </strong>
            .
          </p>
          <p>
            I hold an MBA in Finance, my professional background in business
            operations, project management, contract negotiation, and financial
            control positions me to contribute effectively to the board. My
            experience also includes{" "}
            <strong>
              volunteer work with the Issaquah Chamber of Commerce, Issaquah
              School District and Amnesty International
            </strong>
            , which has further strengthened my commitment to community service.
          </p>
        </CandidateBio>
      </Center>
    </div>
  </Editorial>
);

export default EricaFloden;
